import { UserOrderInfo } from '../../../services/swapV3';
import { TokenMetadata } from '../../../services/ft-contract';
import { HistoryOrderSwapInfo } from '../../../services/indexer';
import { FormattedMessage, useIntl } from 'react-intl';
import React, { useEffect, useState, useMemo } from 'react';
import {
  REF_FI_MY_ORDER_SHOW_HISTORY_SWAP_INFO,
  ORDER_TYPE_KEY,
  SwitchTabItem,
  NoOrderCard,
} from './myOrderShared';
import { useDclPoolIdByCondition } from '../../../state/swapV3';
import { useHistoryOrderTx } from '../../../state/myOrder';
import { useTokens } from '../../../state/token';
import { isMobile } from '../../../utils/device';
import Big from 'big.js';
import {
  toReadableNumber,
  scientificNotationToString,
} from '../../../utils/numbers';
import _ from 'lodash';
import { APP_META } from '../../../services/config';
import { DownArrowVE, UpArrowVE } from '../../icon/Referendum';
import { ActiveLine } from './ActiveLine';
import { HistoryLine } from './HistoryLine';
import CustomTooltip from 'src/components/customTooltip/customTooltip';
import { HistorySwapInfoLine } from './HistorySwapInfoLine';
import { sort_tokens_by_base } from '../../../services/dcl/dclDisplay';

export function OrderCard({
  activeOrder,
  historyOrder,
  tokensMap,
  historySwapInfo,
}: {
  activeOrder: UserOrderInfo[];
  historyOrder: UserOrderInfo[];
  tokensMap: { [key: string]: TokenMetadata };
  historySwapInfo: HistoryOrderSwapInfo[];
}) {
  const intl = useIntl();

  const [showHistoryInfo, setShowHistoryInfo] = useState<boolean>(
    !!sessionStorage.getItem(REF_FI_MY_ORDER_SHOW_HISTORY_SWAP_INFO) || false
  );

  const handleShowHistoryInfo = () => {
    setShowHistoryInfo(!showHistoryInfo);
    if (!showHistoryInfo) {
      sessionStorage.setItem(REF_FI_MY_ORDER_SHOW_HISTORY_SWAP_INFO, 'true');
    } else {
      sessionStorage.removeItem(REF_FI_MY_ORDER_SHOW_HISTORY_SWAP_INFO);
    }
  };
  const pool_id_by_url = useDclPoolIdByCondition('all');

  const [orderType, setOrderType] = useState<'active' | 'history'>(
    sessionStorage.getItem(ORDER_TYPE_KEY) ||
      activeOrder?.length > 0 ||
      !historyOrder ||
      historyOrder.length === 0
      ? 'active'
      : 'history'
  );

  const orderTxs = useHistoryOrderTx();

  const [activeSortBy, setActiveSortBy] = useState<'unclaim' | 'created'>(
    'created'
  );

  const [activeOrderHoverOn, setActiveOrderHoverOn] = useState<number>(-1);

  const [historyOrderHoverOn, setHistoryOrderHoverOn] = useState<number>(-1);
  const [historyInfoOrderHoverOn, setHistoryInfoOrderHoverOn] =
    useState<number>(-1);

  const [sortOrderActive, setSorOrderActive] = useState<'asc' | 'desc'>('desc');

  const [sortOrderHistory, setSorOrderHistory] = useState<'asc' | 'desc'>(
    'desc'
  );

  const [historySortBy, setHistorySortBy] = useState<'claimed' | 'created'>(
    'created'
  );
  const [select_type, set_select_type] = useState<'all' | 'current'>('all');
  const [activeOrderList, setActiveOrderList] = useState<UserOrderInfo[]>();
  const [historyOrderList, setHistoryOrderList] = useState<UserOrderInfo[]>();
  const [historySwapInfoList, setHistorySwapInfoList] =
    useState<HistoryOrderSwapInfo[]>();

  const tokenIds = useMemo(() => {
    if (pool_id_by_url) {
      const [token_x, token_y, fee] = pool_id_by_url.split('|');
      return [token_x, token_y];
    }
    return [];
  }, [pool_id_by_url]);

  const tokens = useTokens(tokenIds) || [];
  const current_pair_tokens_map = tokens.reduce((tokensById, token) => {
    return {
      ...tokensById,
      [token.id]: token,
    };
  }, {});

  useEffect(() => {
    if (activeOrder.length) {
      if (select_type == 'all') {
        setActiveOrderList(activeOrder);
      } else {
        setActiveOrderList(getCurrentPairOrders(activeOrder));
      }
    }
  }, [activeOrder, select_type, pool_id_by_url]);

  useEffect(() => {
    if (historyOrder.length) {
      if (select_type == 'all') {
        setHistoryOrderList(historyOrder);
      } else {
        setHistoryOrderList(getCurrentPairOrders(historyOrder));
      }
    }
  }, [historyOrder, select_type, pool_id_by_url]);
  useEffect(() => {
    if (historySwapInfo.length) {
      if (select_type == 'all') {
        setHistorySwapInfoList(historySwapInfo);
      } else {
        setHistorySwapInfoList(getCurrentPairSwapOrders(historySwapInfo));
      }
    }
  }, [historySwapInfo, select_type, pool_id_by_url]);

  function getCurrentPairOrders(orders: UserOrderInfo[]) {
    return orders.filter((order: UserOrderInfo) => {
      return order.pool_id == pool_id_by_url;
    });
  }
  function getCurrentPairSwapOrders(orders: HistoryOrderSwapInfo[]) {
    return orders.filter((order: HistoryOrderSwapInfo) => {
      return order.pool_id == pool_id_by_url;
    });
  }
  function OrderTab() {
    if (isMobile()) {
      return (
        <div className="frcb w-full">
          <div className="text-white font-gothamBold">
            <FormattedMessage
              id="your_orders"
              defaultMessage={'Your orders'}
            ></FormattedMessage>
          </div>

          <div
            className="flex text-13px p-1 rounded-xl text-white "
            style={{
              border: '1.5px solid rgba(145, 162, 174, 0.2)',
            }}
          >
            <button
              className={`px-3 rounded-lg py-1 ${
                orderType === 'active' ? 'text-white' : 'text-primaryText'
              } `}
              style={{
                background: orderType === 'active' ? '#324451' : '',
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                sessionStorage.setItem(ORDER_TYPE_KEY, 'active');
                setOrderType('active');
              }}
            >
              <span className="frcs">
                <FormattedMessage id="active" defaultMessage={'Active'} />
                {activeOrderList && activeOrderList.length > 0
                  ? ` (${activeOrderList.length})`
                  : null}
              </span>
            </button>

            <button
              className={`px-3 py-1 rounded-lg ${
                orderType === 'history' ? 'text-white' : 'text-primaryText'
              } `}
              style={{
                background: orderType === 'history' ? '#324451' : '',
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setOrderType('history');
                sessionStorage.setItem(ORDER_TYPE_KEY, 'history');
              }}
            >
              <span className="frcs">
                <FormattedMessage id="history" defaultMessage={'History'} />
                {historyOrderList && historyOrderList.length > 0
                  ? ` (${historyOrderList.length})`
                  : null}
              </span>
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="flex whitespace-nowrap  text-white mb-4">
        <button
          className={`mr-7 ${
            orderType === 'active' ? 'text-white' : 'text-primaryText'
          } xs:mr-10 flex flex-col items-center`}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            sessionStorage.setItem(ORDER_TYPE_KEY, 'active');
            setOrderType('active');
          }}
        >
          <span>
            <FormattedMessage
              id="active_orders"
              defaultMessage={'Active Orders'}
            />
            {activeOrderList && activeOrderList.length > 0
              ? ` (${activeOrderList.length})`
              : null}
          </span>

          {orderType === 'active' && (
            <div
              className="w-full mt-2 bg-senderHot"
              style={{
                borderRadius: '3px',
                height: '3px',
              }}
            ></div>
          )}
        </button>

        <button
          className={`${
            orderType === 'history' ? 'text-white' : 'text-primaryText'
          } flex flex-col items-center`}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setOrderType('history');
            sessionStorage.setItem(ORDER_TYPE_KEY, 'history');
          }}
        >
          <span>
            <FormattedMessage id="history" defaultMessage={'History'} />
            {historyOrderList && historyOrderList.length > 0
              ? ` (${historyOrderList.length})`
              : null}
          </span>

          {orderType === 'history' && (
            <div
              className="w-full mt-2 bg-senderHot"
              style={{
                borderRadius: '3px',
                height: '3px',
              }}
            ></div>
          )}
        </button>
      </div>
    );
  }

  const sellAmountToBuyAmount = (
    undecimaled_amount: string,
    order: UserOrderInfo,
    price: string
  ) => {
    const buy_amount = new Big(
      toReadableNumber(
        tokensMap[order.sell_token].decimals,
        undecimaled_amount || '0'
      )
    )
      .times(price)
      .toFixed(tokensMap[order.sell_token].decimals);

    return scientificNotationToString(buy_amount);
  };

  const historyOrderSorting = (
    orderA: UserOrderInfo,
    orderB: UserOrderInfo
  ) => {
    if (historySortBy === 'created') {
      return sortOrderHistory === 'desc'
        ? Number(orderB.created_at) - Number(orderA.created_at)
        : Number(orderA.created_at) - Number(orderB.created_at);
    } else if (historySortBy === 'claimed') {
      const claimA = toReadableNumber(
        tokensMap[orderA.buy_token].decimals,
        orderA.bought_amount || '0'
      );
      const claimB = toReadableNumber(
        tokensMap[orderB.buy_token].decimals,
        orderB.bought_amount || '0'
      );

      return sortOrderHistory === 'desc'
        ? Number(claimB) - Number(claimA)
        : Number(claimA) - Number(claimB);
    }
  };

  const activeOrderSorting = (orderA: UserOrderInfo, orderB: UserOrderInfo) => {
    if (activeSortBy === 'created') {
      return sortOrderActive === 'desc'
        ? Number(orderB.created_at) - Number(orderA.created_at)
        : Number(orderA.created_at) - Number(orderB.created_at);
    } else if (activeSortBy === 'unclaim') {
      const unclaimA = toReadableNumber(
        tokensMap[orderA.buy_token].decimals,
        orderA.unclaimed_amount
      );
      const unclaimB = toReadableNumber(
        tokensMap[orderB.buy_token].decimals,
        orderB.unclaimed_amount
      );

      return sortOrderActive === 'desc'
        ? Number(unclaimB) - Number(unclaimA)
        : Number(unclaimA) - Number(unclaimB);
    }
  };

  function getRealTimeOrderTip() {
    const intl = useIntl();
    return `<div class=" rounded-md lg:w-p200 xs:w-44 text-primaryOrderly  text-xs  text-left">
  
      ${intl.formatMessage(
        {
          id: 'real_time_executed_orders_tip',
          defaultMessage:
            'Real-time executed orders are orders placed using limit order function.  Here, you can check real-time executed orders that have been executed between the earliest displayed limit order in History up to the present time.',
        },
        // This tooltip is HTML.
        { appName: _.escape(APP_META.name) }
      )}
  
    </div>`;
  }
  function get_current_pairs() {
    if (pool_id_by_url && current_pair_tokens_map) {
      const [token_x, token_y, fee] = pool_id_by_url.split('|');
      const token_x_meta = current_pair_tokens_map[token_x];
      const token_y_meta = current_pair_tokens_map[token_y];
      if (token_x_meta?.symbol && token_y_meta?.symbol) {
        const tokens = sort_tokens_by_base([token_x_meta, token_y_meta]);
        return `${tokens[0].symbol}-${tokens[1].symbol}`;
      }
    }
    return '';
  }
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between xsm:flex-col xsm:items-end">
        {OrderTab()}
        <div className="flex items-center gap-6 xsm:mt-4 mb-4">
          <SwitchTabItem
            active={select_type == 'current'}
            clickEvent={() => {
              set_select_type('current');
            }}
          >
            Current: {get_current_pairs()}
          </SwitchTabItem>
          <SwitchTabItem
            active={select_type == 'all'}
            clickEvent={() => {
              set_select_type('all');
            }}
          >
            All
          </SwitchTabItem>
        </div>
      </div>

      {orderType === 'history' &&
        (!historyOrder || historyOrder.length === 0) && (
          <NoOrderCard text="history" />
        )}
      {orderType === 'active' && (!activeOrder || activeOrder.length === 0) && (
        <NoOrderCard text="active" />
      )}

      <table
        className="border-separate xsm:block"
        style={{
          borderSpacing: 0,
        }}
        onMouseLeave={() => {
          setActiveOrderHoverOn(-1);
          setHistoryOrderHoverOn(-1);
        }}
      >
        {orderType === 'active' && (
          <>
            <tr
              className={`mb-2.5 px-4 xs:hidden ${
                !activeOrder || activeOrder.length === 0 ? 'hidden' : ''
              } text-v3SwapGray text-sm  grid-cols-7 whitespace-nowrap`}
              onMouseEnter={() => {
                setActiveOrderHoverOn(-1);
                setHistoryOrderHoverOn(-1);
              }}
            >
              <th className="col-span-1 pl-3 text-left">
                <FormattedMessage id="you_sell" defaultMessage={'You Sell'} />
              </th>

              <th></th>

              <th className="col-span-1 text-left">
                <FormattedMessage id="you_buy" defaultMessage={'You Buy'} />
              </th>

              <th className=""></th>

              <th className=""></th>

              <th className="col-span-1 text-left">
                <FormattedMessage id="@price" defaultMessage={'@Price'} />
              </th>

              <th>
                <button
                  className="col-span-1 flex items-center "
                  onClick={() => {
                    setActiveSortBy('created');
                    if (activeSortBy === 'created') {
                      if (sortOrderActive === 'asc') {
                        setSorOrderActive('desc');
                      } else {
                        setSorOrderActive('asc');
                      }
                    } else {
                      setSorOrderActive('desc');
                    }
                  }}
                >
                  <FormattedMessage id="created" defaultMessage={'Created'} />

                  <span
                    className={`ml-0.5 ${
                      activeSortBy === 'created' ? 'text-gradientFrom' : ''
                    }`}
                  >
                    {activeSortBy === 'created' && sortOrderActive === 'asc' ? (
                      <UpArrowVE />
                    ) : (
                      <DownArrowVE />
                    )}
                  </span>
                </button>
              </th>

              <th>
                <button
                  className="col-span-1 flex items-center  text-right"
                  onClick={() => {
                    setActiveSortBy('unclaim');
                    if (activeSortBy === 'unclaim') {
                      if (sortOrderActive === 'asc') {
                        setSorOrderActive('desc');
                      } else {
                        setSorOrderActive('asc');
                      }
                    } else {
                      setSorOrderActive('desc');
                    }
                  }}
                >
                  <FormattedMessage id="executed" defaultMessage={'Executed'} />
                  <span
                    className={`ml-0.5 ${
                      activeSortBy === 'unclaim' ? 'text-gradientFrom' : ''
                    }`}
                  >
                    {activeSortBy === 'unclaim' && sortOrderActive === 'asc' ? (
                      <UpArrowVE />
                    ) : (
                      <DownArrowVE />
                    )}
                  </span>
                </button>
              </th>
            </tr>
          </>
        )}

        {orderType === 'history' && (
          <>
            <tr
              className={`mb-2.5 px-4 xs:hidden ${
                !historyOrder || historyOrder.length === 0 ? 'hidden' : ''
              } text-v3SwapGray text-sm  whitespace-nowrap`}
              onMouseEnter={() => {
                setActiveOrderHoverOn(-1);
                setHistoryOrderHoverOn(-1);
              }}
            >
              <th className="pl-3 text-left">
                <FormattedMessage id="you_sell" defaultMessage={'You Sell'} />
              </th>

              <th></th>

              <th className="text-left">
                <FormattedMessage id="you_buy" defaultMessage={'You Buy'} />
              </th>

              <th className=""></th>

              <th className="col-span-1 text-left">
                <FormattedMessage id="@price" defaultMessage={'@Price'} />
              </th>

              <th>
                <button
                  className=" flex items-center"
                  onClick={() => {
                    setHistorySortBy('created');
                    if (historySortBy === 'created') {
                      if (sortOrderHistory === 'asc') {
                        setSorOrderHistory('desc');
                      } else {
                        setSorOrderHistory('asc');
                      }
                    } else {
                      setSorOrderHistory('desc');
                    }
                  }}
                >
                  <FormattedMessage id="created" defaultMessage={'Created'} />

                  <span
                    className={`ml-0.5 ${
                      historySortBy === 'created' ? 'text-gradientFrom' : ''
                    }`}
                  >
                    {historySortBy === 'created' &&
                    sortOrderHistory === 'asc' ? (
                      <UpArrowVE />
                    ) : (
                      <DownArrowVE />
                    )}
                  </span>
                </button>
              </th>

              <th>
                <button
                  className="col-span-2 flex items-center text-right"
                  onClick={() => {
                    setHistorySortBy('claimed');
                    if (historySortBy === 'claimed') {
                      if (sortOrderHistory === 'asc') {
                        setSorOrderHistory('desc');
                      } else {
                        setSorOrderHistory('asc');
                      }
                    } else {
                      setSorOrderHistory('desc');
                    }
                  }}
                >
                  <FormattedMessage id="executed" defaultMessage={'Executed'} />
                  <span
                    className={`ml-0.5 ${
                      historySortBy === 'claimed' ? 'text-gradientFrom' : ''
                    }`}
                  >
                    {historySortBy === 'claimed' &&
                    sortOrderHistory === 'asc' ? (
                      <UpArrowVE />
                    ) : (
                      <DownArrowVE />
                    )}
                  </span>
                </button>
              </th>

              <th className="col-span-1 text-right">
                <span className="pr-4">
                  <FormattedMessage id="status" defaultMessage={'Status'} />
                </span>
              </th>
            </tr>
          </>
        )}

        {orderType === 'active' &&
          activeOrderList &&
          activeOrderList.sort(activeOrderSorting).map((order, index) => {
            return (
              <ActiveLine
                tokensMap={tokensMap}
                hoverOn={activeOrderHoverOn}
                setHoverOn={setActiveOrderHoverOn}
                sellAmountToBuyAmount={sellAmountToBuyAmount}
                index={index}
                key={order.order_id}
                order={order}
                orderTx={
                  orderTxs?.find(
                    (orderTx) => orderTx.order_id === order.order_id
                  )?.receipt_id || ''
                }
              />
            );
          })}
        {orderType === 'history' &&
          historyOrderList &&
          historyOrderList.sort(historyOrderSorting).map((order, index) => {
            return (
              <HistoryLine
                index={index}
                key={order.order_id}
                order={order}
                tokensMap={tokensMap}
                sellAmountToBuyAmount={sellAmountToBuyAmount}
                orderTx={
                  orderTxs?.find(
                    (orderTx) => orderTx.order_id === order.order_id
                  )?.receipt_id || ''
                }
                setHoverOn={setHistoryOrderHoverOn}
                hoverOn={historyOrderHoverOn}
              />
            );
          })}
        {orderType === 'history' &&
          historySwapInfo &&
          historySwapInfo.length > 0 && (
            <tr
              onMouseEnter={() => {
                setActiveOrderHoverOn(-1);
                setHistoryOrderHoverOn(-1);
              }}
            >
              <td colSpan={8}>
                <div
                  className="inline-flex max-w-max items-center ml-4 text-primaryText mt-7  mb-3"
                  data-class="reactTip"
                  data-tooltip-id={'real_time_order_tip'}
                  data-place={'top'}
                  data-tooltip-html={getRealTimeOrderTip()}
                >
                  <span
                    className={`underline cursor-pointer ${'lg:hover:text-white'} `}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleShowHistoryInfo();
                    }}
                    style={{
                      textDecorationThickness: '1px',
                    }}
                  >
                    {intl.formatMessage({
                      id: showHistoryInfo ? 'hide' : 'show',
                      defaultMessage: showHistoryInfo ? 'Hide' : 'Show',
                    })}
                  </span>

                  <span className="ml-1">
                    {intl.formatMessage({
                      id: 'real_time_executed_orders',
                      defaultMessage: 'real-time executed orders',
                    })}
                  </span>
                  <CustomTooltip id={'real_time_order_tip'} place="top" />
                </div>
              </td>
            </tr>
          )}
        {orderType === 'history' &&
          showHistoryInfo &&
          historySwapInfoList &&
          historySwapInfoList.length > 0 &&
          historySwapInfoList
            .sort(
              (swapInfoA, swapInfoB) =>
                Number(swapInfoB.timestamp) - Number(swapInfoA.timestamp)
            )
            .map((swapInfo, index) => {
              return (
                <HistorySwapInfoLine
                  index={index}
                  tokensMap={tokensMap}
                  key={swapInfo.receipt_id}
                  token_in={swapInfo.token_in}
                  token_out={swapInfo.token_out}
                  amount_in={swapInfo.amount_in}
                  amount_out={swapInfo.amount_out}
                  orderTx={swapInfo.receipt_id}
                  timestamp={swapInfo.timestamp}
                  point={swapInfo.point}
                  pool_id={swapInfo.pool_id}
                  hoverOn={historyInfoOrderHoverOn}
                  setHoverOn={setHistoryInfoOrderHoverOn}
                />
              );
            })}
      </table>
    </div>
  );
}
